import React from "react";

export default function StatCard({ label, value, hint }) {
  return (
    <div className="card">
      <div className="muted">{label}</div>
      <h3>{value}</h3>
      {hint ? <div className="muted">{hint}</div> : null}
    </div>
  );
}
